const _excluded = ["options", "selectedValue", "disabled", "errorMessage", "hasContainer", "name", "analyticsName", "trackImpression", "aria-label", "aria-labelledby", "role", "onClick", "containerProps"],
  _excluded2 = ["value"],
  _excluded3 = ["value"];
function cov_i56qkotng() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/Radio/RadioGroup.tsx";
  var hash = "268c1fd01284d94e6159f0aabb1653af972f8e7e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/Radio/RadioGroup.tsx",
    statementMap: {
      "0": {
        start: {
          line: 161,
          column: 81
        },
        end: {
          line: 236,
          column: 1
        }
      },
      "1": {
        start: {
          line: 177,
          column: 20
        },
        end: {
          line: 177,
          column: 93
        }
      },
      "2": {
        start: {
          line: 179,
          column: 2
        },
        end: {
          line: 203,
          column: 3
        }
      },
      "3": {
        start: {
          line: 180,
          column: 38
        },
        end: {
          line: 180,
          column: 48
        }
      },
      "4": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 202,
          column: 6
        }
      },
      "5": {
        start: {
          line: 192,
          column: 48
        },
        end: {
          line: 192,
          column: 62
        }
      },
      "6": {
        start: {
          line: 205,
          column: 2
        },
        end: {
          line: 235,
          column: 4
        }
      },
      "7": {
        start: {
          line: 215,
          column: 8
        },
        end: {
          line: 227,
          column: 10
        }
      },
      "8": {
        start: {
          line: 224,
          column: 48
        },
        end: {
          line: 224,
          column: 62
        }
      },
      "9": {
        start: {
          line: 245,
          column: 31
        },
        end: {
          line: 257,
          column: 1
        }
      },
      "10": {
        start: {
          line: 250,
          column: 42
        },
        end: {
          line: 250,
          column: 70
        }
      },
      "11": {
        start: {
          line: 251,
          column: 22
        },
        end: {
          line: 254,
          column: 3
        }
      },
      "12": {
        start: {
          line: 252,
          column: 4
        },
        end: {
          line: 252,
          column: 27
        }
      },
      "13": {
        start: {
          line: 253,
          column: 4
        },
        end: {
          line: 253,
          column: 61
        }
      },
      "14": {
        start: {
          line: 256,
          column: 2
        },
        end: {
          line: 256,
          column: 39
        }
      },
      "15": {
        start: {
          line: 357,
          column: 53
        },
        end: {
          line: 360,
          column: 1
        }
      },
      "16": {
        start: {
          line: 358,
          column: 40
        },
        end: {
          line: 358,
          column: 57
        }
      },
      "17": {
        start: {
          line: 359,
          column: 2
        },
        end: {
          line: 359,
          column: 100
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 161,
            column: 81
          },
          end: {
            line: 161,
            column: 82
          }
        },
        loc: {
          start: {
            line: 176,
            column: 6
          },
          end: {
            line: 236,
            column: 1
          }
        },
        line: 176
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 192,
            column: 42
          },
          end: {
            line: 192,
            column: 43
          }
        },
        loc: {
          start: {
            line: 192,
            column: 48
          },
          end: {
            line: 192,
            column: 62
          }
        },
        line: 192
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 214,
            column: 19
          },
          end: {
            line: 214,
            column: 20
          }
        },
        loc: {
          start: {
            line: 215,
            column: 8
          },
          end: {
            line: 227,
            column: 10
          }
        },
        line: 215
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 224,
            column: 42
          },
          end: {
            line: 224,
            column: 43
          }
        },
        loc: {
          start: {
            line: 224,
            column: 48
          },
          end: {
            line: 224,
            column: 62
          }
        },
        line: 224
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 245,
            column: 31
          },
          end: {
            line: 245,
            column: 32
          }
        },
        loc: {
          start: {
            line: 249,
            column: 5
          },
          end: {
            line: 257,
            column: 1
          }
        },
        line: 249
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 248,
            column: 55
          },
          end: {
            line: 248,
            column: 56
          }
        },
        loc: {
          start: {
            line: 248,
            column: 61
          },
          end: {
            line: 248,
            column: 63
          }
        },
        line: 248
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 251,
            column: 22
          },
          end: {
            line: 251,
            column: 23
          }
        },
        loc: {
          start: {
            line: 251,
            column: 41
          },
          end: {
            line: 254,
            column: 3
          }
        },
        line: 251
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 357,
            column: 53
          },
          end: {
            line: 357,
            column: 54
          }
        },
        loc: {
          start: {
            line: 357,
            column: 64
          },
          end: {
            line: 360,
            column: 1
          }
        },
        line: 357
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 163,
            column: 2
          },
          end: {
            line: 163,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 163,
            column: 18
          },
          end: {
            line: 163,
            column: 20
          }
        }],
        line: 163
      },
      "1": {
        loc: {
          start: {
            line: 172,
            column: 2
          },
          end: {
            line: 172,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 172,
            column: 9
          },
          end: {
            line: 172,
            column: 21
          }
        }],
        line: 172
      },
      "2": {
        loc: {
          start: {
            line: 179,
            column: 2
          },
          end: {
            line: 203,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 179,
            column: 2
          },
          end: {
            line: 203,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 179
      },
      "3": {
        loc: {
          start: {
            line: 192,
            column: 19
          },
          end: {
            line: 192,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 192,
            column: 30
          },
          end: {
            line: 192,
            column: 39
          }
        }, {
          start: {
            line: 192,
            column: 42
          },
          end: {
            line: 192,
            column: 62
          }
        }],
        line: 192
      },
      "4": {
        loc: {
          start: {
            line: 196,
            column: 9
          },
          end: {
            line: 200,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 197,
            column: 10
          },
          end: {
            line: 199,
            column: 17
          }
        }, {
          start: {
            line: 200,
            column: 12
          },
          end: {
            line: 200,
            column: 16
          }
        }],
        line: 196
      },
      "5": {
        loc: {
          start: {
            line: 209,
            column: 12
          },
          end: {
            line: 209,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 209,
            column: 29
          },
          end: {
            line: 209,
            column: 33
          }
        }, {
          start: {
            line: 209,
            column: 36
          },
          end: {
            line: 209,
            column: 45
          }
        }],
        line: 209
      },
      "6": {
        loc: {
          start: {
            line: 224,
            column: 19
          },
          end: {
            line: 224,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 224,
            column: 30
          },
          end: {
            line: 224,
            column: 39
          }
        }, {
          start: {
            line: 224,
            column: 42
          },
          end: {
            line: 224,
            column: 62
          }
        }],
        line: 224
      },
      "7": {
        loc: {
          start: {
            line: 229,
            column: 7
          },
          end: {
            line: 233,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 230,
            column: 8
          },
          end: {
            line: 232,
            column: 15
          }
        }, {
          start: {
            line: 233,
            column: 10
          },
          end: {
            line: 233,
            column: 14
          }
        }],
        line: 229
      },
      "8": {
        loc: {
          start: {
            line: 247,
            column: 2
          },
          end: {
            line: 247,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 247,
            column: 25
          },
          end: {
            line: 247,
            column: 27
          }
        }],
        line: 247
      },
      "9": {
        loc: {
          start: {
            line: 248,
            column: 2
          },
          end: {
            line: 248,
            column: 63
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 248,
            column: 55
          },
          end: {
            line: 248,
            column: 63
          }
        }],
        line: 248
      },
      "10": {
        loc: {
          start: {
            line: 250,
            column: 51
          },
          end: {
            line: 250,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 250,
            column: 51
          },
          end: {
            line: 250,
            column: 63
          }
        }, {
          start: {
            line: 250,
            column: 67
          },
          end: {
            line: 250,
            column: 69
          }
        }],
        line: 250
      },
      "11": {
        loc: {
          start: {
            line: 253,
            column: 4
          },
          end: {
            line: 253,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 253,
            column: 4
          },
          end: {
            line: 253,
            column: 11
          }
        }, {
          start: {
            line: 253,
            column: 15
          },
          end: {
            line: 253,
            column: 60
          }
        }],
        line: 253
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0],
      "9": [0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "268c1fd01284d94e6159f0aabb1653af972f8e7e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_i56qkotng = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_i56qkotng();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import { useTrackComponentInView } from "../../../hooks/useObservabilitySafe.mjs";
import { Flex, Text } from "../../index.mjs";
import { Radio } from "../CheckboxOrRadio.mjs";

/**
 * INSTRUCTIONS FOR RADIO GROUP:
 *   There are two types of components for radio group:
 *   option 1) Presentational radio group that is just there for design
 *   option 2) A stateful radio group that handles all the default logic for the consumer
 *   Please choose the one that is best suited for your needs
 */
/**
 * OPTION 1: PRESENTATIONAL RADIO GROUP Radio Group is purely presentational
 * This does not handle keeping track of selected values handleChange &
 * handleClick. Consumer must handle these themselves.  If you would like the
 * bricks component to handle this please use RadioGroup which is a combination
 * of PresentationalRadioGroup & the hook with default logic
 *
 * Radio buttons allow the user to select one option from a set. Use radio
 * buttons when the user needs to see all available options. If available
 * options can be collapsed, consider using a dropdown menu because it uses less
 * space.
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * Radio buttons are elements for making selections. Radio buttons allow the
 * user to choose exactly one item from a list of several predefined
 * alternatives.
 *
 * *   Avoid using nested radio buttons because it is very difficult to make
 * them accessible.
 *
 * *   Radios need to support proper keyboard interactions.
 *
 * *   Radios should always have a focus indicator visible and have sufficient
 * contrast.
 *
 * *   Radios must have the correct WAI-ARIA tags
 *
 * *   Each Radio button must have a value of aria-checked to define the state
 * of the radio or checkbox.
 *
 * *   Each Radio button element needs to have a "radio" role assigned to them.
 *
 * *   Each Radio button needs to have a value attribute attached. The value
 * attribute is a DOMString containing the button’s value.
 *
 * *   Each Radio button needs to have a unique id, which is used by the
 * element's for attribute to associate the labels with the buttons.
 *
 * *   Groups of radio buttons must be grouped together through (1) fieldsets
 * and legends or (2) WAI-ARIA tags. We have decided to use Option 2.
 *
 * *   Option 1: Fieldset & legend:
 *
 * *   The `<fieldset>` element provides a container for related form controls.
 *
 * *   The `<legend>` element acts as a heading to identify the group.
 *
 * *   `<fieldset> <legend>Breed of Chicken to be Culled</legend> <label
 * for="chicken-1">Plymouth Rock</label> <input type="radio" name="chicken"
 * id="chicken-1" value="Plymouth Rock"> <label for="chicken-2">Buff
 * Orpington</label> <input type="radio" name="chicken" id="chicken-2"
 * value="Buff Orpington"> <label for="chicken-3">Leghorn</label> <input
 * type="radio" name="chicken" id="chicken-3" value="Leghorn"> </fieldset>`
 *
 * *   Option 2: WAI-ARIA tags:
 *
 * *   Radio/checkbox groups you’ll need an aria-label to describe the
 * radio/checkbox group. Optionally you can add an aria-labelledby if there is
 * an element on the page that labels the radio/checkbox group for you
 *
 * *   Radio/checkbox groups are defined by giving each of the radio buttons in
 * the group the same name - this is not required if you only have one radio
 *
 * *   Radio elements must be grouped together by an element with a "radiogroup"
 * role to indicate which ones affect the same value.
 *
 * *   `<div role="radiogroup" aria-label="Who makes the best fast-food
 * breakfast?"> <input type="radio" id="probably" name="breakfast"
 * value="probably"> <label for="probably">Probably Taco Bell.</label> <input
 * type="radio" id="definitely" name="breakfast" value="definitely"> <label
 * for="definitely">Definitely Taco Bell.</label> </div>`
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Radio` is set up to track click and impression events:
 *
 * *   To track click events of the radio option pass in an non-empty
 * `analyticsName` (convention: {appName}-{radioName}) Click events are tracked
 * for each radio option
 *
 * *   To track impression events of the radio group pass: 1) a non-empty
 * `analyticsName` 2) pass `trackImpression={true}` Radio group impression
 * events will only be tracked the first time that the radio group enters the
 * viewport. We only track impression events of the radio group (not each radio
 * option)
 *
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_radio\_view\_event for radio
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 *
 */
cov_i56qkotng().s[0]++;
export const PresentationalRadioGroup = _ref => {
  let {
      options,
      selectedValue = (cov_i56qkotng().b[0][0]++, ''),
      disabled,
      errorMessage,
      hasContainer,
      name,
      analyticsName,
      trackImpression,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelBy,
      role = (cov_i56qkotng().b[1][0]++, 'radiogroup'),
      onClick,
      containerProps
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_i56qkotng().f[0]++;
  const inViewRef = (cov_i56qkotng().s[1]++, useTrackComponentInView('radioViewEvent', trackImpression, analyticsName));
  cov_i56qkotng().s[2]++;
  if (options.length === 1) {
    cov_i56qkotng().b[2][0]++;
    const _ref2 = (cov_i56qkotng().s[3]++, options[0]),
      {
        value
      } = _ref2,
      optionProps = _objectWithoutProperties(_ref2, _excluded2);
    cov_i56qkotng().s[4]++;
    return /*#__PURE__*/React.createElement(Flex, _extends({
      ref: inViewRef,
      flexDirection: "column"
    }, containerProps), /*#__PURE__*/React.createElement(Radio, _extends({
      analyticsName: analyticsName,
      checked: selectedValue === value,
      disabled: disabled,
      errorMessage: errorMessage,
      hasContainer: hasContainer,
      key: value,
      name: name,
      value: value,
      onClick: disabled ? (cov_i56qkotng().b[3][0]++, undefined) : (cov_i56qkotng().b[3][1]++, () => {
        cov_i56qkotng().f[1]++;
        cov_i56qkotng().s[5]++;
        return onClick(value);
      })
    }, optionProps, props)), errorMessage !== undefined ? (cov_i56qkotng().b[4][0]++, /*#__PURE__*/React.createElement(Text, {
      color: "red50",
      fontSize: "s1",
      "data-testid": 'error messaging'
    }, errorMessage)) : (cov_i56qkotng().b[4][1]++, null));
  } else {
    cov_i56qkotng().b[2][1]++;
  }
  cov_i56qkotng().s[6]++;
  return /*#__PURE__*/React.createElement(Flex, _extends({
    ref: inViewRef,
    flexDirection: "column",
    role: role != 'none' ? (cov_i56qkotng().b[5][0]++, role) : (cov_i56qkotng().b[5][1]++, undefined),
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelBy
  }, containerProps), options.map(_ref3 => {
    let {
        value
      } = _ref3,
      optionProps = _objectWithoutProperties(_ref3, _excluded3);
    cov_i56qkotng().f[2]++;
    cov_i56qkotng().s[7]++;
    return /*#__PURE__*/React.createElement(Radio, _extends({
      analyticsName: analyticsName,
      checked: selectedValue === value,
      disabled: disabled,
      errorMessage: errorMessage,
      hasContainer: hasContainer,
      key: value,
      name: name,
      value: value,
      onClick: disabled ? (cov_i56qkotng().b[6][0]++, undefined) : (cov_i56qkotng().b[6][1]++, () => {
        cov_i56qkotng().f[3]++;
        cov_i56qkotng().s[8]++;
        return onClick(value);
      })
    }, optionProps, props));
  }), errorMessage !== undefined ? (cov_i56qkotng().b[7][0]++, /*#__PURE__*/React.createElement(Text, {
    color: "red50",
    fontSize: "s1",
    "data-testid": 'error messaging'
  }, errorMessage)) : (cov_i56qkotng().b[7][1]++, null));
};

/**
 * This hook handles keeping track of selected values & the handleClick.
 * It is used in the stateful radio group that handles all the default logic for the consumer
 * useRadioHandler handles:
 *   1) default radio handling logic
 *   2) keeps track of checked values
 */
cov_i56qkotng().s[9]++;
export const useRadioHandler = function () {
  let initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_i56qkotng().b[8][0]++, '');
  let onClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_i56qkotng().b[9][0]++, () => {
    cov_i56qkotng().f[5]++;
  });
  cov_i56qkotng().f[4]++;
  const [checkedValue, setCheckedValue] = (cov_i56qkotng().s[10]++, useState((cov_i56qkotng().b[10][0]++, initialValue) ?? (cov_i56qkotng().b[10][1]++, '')));
  cov_i56qkotng().s[11]++;
  const handleClick = value => {
    cov_i56qkotng().f[6]++;
    cov_i56qkotng().s[12]++;
    setCheckedValue(value);
    cov_i56qkotng().s[13]++;
    (cov_i56qkotng().b[11][0]++, onClick) && (cov_i56qkotng().b[11][1]++, onClick(checkedValue, checkedValue === value));
  };
  cov_i56qkotng().s[14]++;
  return {
    checkedValue,
    handleClick
  };
};

/**
 * OPTION 2: STATEFUL RADIO GROUP: A stateful radio group that handles all the
 * default logic for the consumer This radio group keeps track of selected
 * values & the handleClick by calling the useRadioHandler
 *
 * Radio buttons allow the user to select one option from a set. Use radio
 * buttons when the user needs to see all available options. If available
 * options can be collapsed, consider using a dropdown menu because it uses less
 * space.
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * Radio buttons are elements for making selections. Radio buttons allow the
 * user to choose exactly one item from a list of several predefined
 * alternatives.
 *
 * *   Avoid using nested radio buttons because it is very difficult to make
 * them accessible.
 *
 * *   Radios need to support proper keyboard interactions.
 *
 * *   Radios should always have a focus indicator visible and have sufficient
 * contrast.
 *
 * *   Radios must have the correct WAI-ARIA tags
 *
 * *   Each Radio button must have a value of aria-checked to define the state
 * of the radio or checkbox.
 *
 * *   Each Radio button element needs to have a "radio" role assigned to them.
 *
 * *   Each Radio button needs to have a value attribute attached. The value
 * attribute is a DOMString containing the button’s value.
 *
 * *   Each Radio button needs to have a unique id, which is used by the
 * element's for attribute to associate the labels with the buttons.
 *
 * *   Groups of radio buttons must be grouped together through (1) fieldsets
 * and legends or (2) WAI-ARIA tags. We have decided to use Option 2.
 *
 * *   Option 1: Fieldset & legend:
 *
 * *   The `<fieldset>` element provides a container for related form controls.
 *
 * *   The `<legend>` element acts as a heading to identify the group.
 *
 * *   `<fieldset> <legend>Breed of Chicken to be Culled</legend> <label
 * for="chicken-1">Plymouth Rock</label> <input type="radio" name="chicken"
 * id="chicken-1" value="Plymouth Rock"> <label for="chicken-2">Buff
 * Orpington</label> <input type="radio" name="chicken" id="chicken-2"
 * value="Buff Orpington"> <label for="chicken-3">Leghorn</label> <input
 * type="radio" name="chicken" id="chicken-3" value="Leghorn"> </fieldset>`
 *
 * *   Option 2: WAI-ARIA tags:
 *
 * *   Radio/checkbox groups you’ll need an aria-label to describe the
 * radio/checkbox group. Optionally you can add an aria-labelledby if there is
 * an element on the page that labels the radio/checkbox group for you
 *
 * *   Radio/checkbox groups are defined by giving each of the radio buttons in
 * the group the same name - this is not required if you only have one radio
 *
 * *   Radio elements must be grouped together by an element with a "radiogroup"
 * role to indicate which ones affect the same value.
 *
 * *   `<div role="radiogroup" aria-label="Who makes the best fast-food
 * breakfast?"> <input type="radio" id="probably" name="breakfast"
 * value="probably"> <label for="probably">Probably Taco Bell.</label> <input
 * type="radio" id="definitely" name="breakfast" value="definitely"> <label
 * for="definitely">Definitely Taco Bell.</label> </div>`
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Radio` is set up to track click and impression events:
 *
 * *   To track click events of the radio option pass in an non-empty
 * `analyticsName` (convention: {appName}-{radioName}) Click events are tracked
 * for each radio option
 *
 * *   To track impression events of the radio group pass: 1) a non-empty
 * `analyticsName` 2) pass `trackImpression={true}` Radio group impression
 * events will only be tracked the first time that the radio group enters the
 * viewport. We only track impression events of the radio group (not each radio
 * option)
 *
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_radio\_view\_event for radio
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
cov_i56qkotng().s[15]++;
export const RadioGroup = props => {
  cov_i56qkotng().f[7]++;
  const {
    checkedValue,
    handleClick
  } = (cov_i56qkotng().s[16]++, useRadioHandler());
  cov_i56qkotng().s[17]++;
  return /*#__PURE__*/React.createElement(PresentationalRadioGroup, _extends({
    selectedValue: checkedValue,
    onClick: handleClick
  }, props));
};